import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import { createPinia } from 'pinia';
import { createHead } from '@vueuse/head';
import VueNativeSock from 'vue-native-websocket-vue3';
import { v4 as uuidv4 } from 'uuid';
import VueCookies from 'vue-cookies';

import { createStore } from 'vuex';

import auth from "./views/auth/Store.js";
import categorys from "./views/portal/categorys/Store.js";
import companys from "./views/portal/companys/Store.js";
import employees from "./views/portal/employees/Store.js";
import makers from "./views/portal/makers/Store.js";
import schedules from "./views/portal/schedules/Store.js";
import types from "./views/portal/types/Store.js";
import signatures from "./views/portal/signatures/Store.js";
import users from "./views/portal/users/Store.js";
import vehicles from "./views/portal/vehicles/Store.js";
import repairs from "./views/portal/repairs/Store.js";
import repairResults from "./views/portal/repairs/result/Store.js";
import features from "./views/portal/features/Store.js";
import results from "./views/portal/results/Store.js";
import questions from "./views/portal/questions/Store.js";
import options from "./views/portal/options/Store.js";
import inspections from "./views/portal/inspections/Store.js";
import roles from "./views/portal/roles/Store.js";
import register from "./views/register/Store.js";
import signIn from "./views/sign/in/Store.js";
import profile from "./views/portal/profile/Store.js";
import events from "./views/portal/events/Store.js";

import AppStatsStorage from "@/storage/AppStatsStorage.js";
import AddressStorage from "@/storage/AddressStorage.js";
import AnswerStorage from "@/storage/AnswerStorage.js";
import AssetStorage from "@/storage/AssetStorage.js";
import ResultStorage from "@/storage/ResultStorage.js";
import CardStorage from "@/storage/CardStorage.js";
import NoteStorage from "@/storage/NoteStorage.js";

import InvoiceStorage from "@/storage/InvoiceStorage.js";
import PaymentStorage from "@/storage/PaymentStorage.js";
import InvoiceItemsStorage from "@/storage/InvoiceItemsStorage.js";
import InvoiceSettingsStorage from "@/storage/InvoiceSettingsStorage.js";

import TimesheetStorage from "@/storage/TimesheetStorage.js";
import TimesheetEntryStorage from "@/storage/TimesheetEntryStorage.js";

import CommentStorage from "@/domain/model/comment/CommentStorage.js";
import CheckInStorage from "@/domain/model/checkin/CheckInStorage.js";

import EmployeePreferencesStorage from "@/domain/model/employee/preferences/EmployeePreferencesStorage.js";
import EmployeeRecordStorage from "@/domain/model/employee/record/EmployeeRecordStorage.js";

import HomeState from "@/portals/customer/operator/views/home/HomeState.js";
import TimesheetsState from "@/portals/customer/operator/views/timesheet/list/TimesheetsState.js";
import InvoicesModel from "@/portals/customer/operator/views/invoice/list/InvoicesModel.js";

import ImageStorage from "@/domain/model/image/ImageStorage.js";

import CheckListStorage from "@/domain/model/checklist/CheckListStorage.js";
import ChecklistResultStorage from "@/domain/model/checklist/result/ChecklistResultStorage.js";
import CheckListItemStorage from "@/domain/model/checklist/item/CheckListItemStorage.js";
import ChecklistItemResultStorage from "@/domain/model/checklist/item/result/ChecklistItemResultStorage.js";
import CheckListItemOptionStorage from "@/domain/model/checklist/item/option/CheckListItemOptionStorage.js";

import EquipmentStorage from "@/domain/model/equipment/EquipmentStorage.js";
import ReportStorage from "@/domain/model/report/ReportStorage.js";
import LabelStorage from './domain/model/label/LabelStorage.js';
import RegistrationStorage from "@/domain/model/registration/RegistrationStorage.js";

import CompanyListViewStorage from "@/portals/customer/operator/views/company/list/ListViewStorage.js";
import CardListViewStorage from "@/portals/admin/views/cards/list/ListViewStorage.js";
import EmployeeListViewStorage from "@/portals/customer/operator/views/employee/list/ListViewStorage.js";
import InspectionListViewStorage from "@/portals/customer/operator/views/inspection/list/ListViewStorage.js";
import ReportListViewStorage from "@/portals/customer/operator/views/report/list/ListViewStorage.js";
import EquipmentListViewStorage from "@/portals/customer/operator/views/equipment/list/ListViewStorage.js";
import VehicleListViewStorage from "@/portals/customer/operator/views/vehicle/list/ListViewStorage.js";
import ChecklistListVIewStorage from "@/portals/customer/operator/views/checklist/list/ListViewStorage.js";
import TimesheetListViewStorage from "@/portals/customer/operator/views/timesheet/list/ListViewStorage.js";
import BillingListViewStorage from "@/portals/customer/operator/views/billing/list/ListViewStorage.js";
import ComplianceListViewStorage from "@/portals/customer/operator/views/compliance/list/ListViewStorage.js";
import ScheduleListViewStorage from "@/portals/customer/operator/views/schedule/list/ListViewStorage.js";
import CredentialsStorage from "@/domain/model/user/CredentialsStorage.js";
import GpsDeviceStorage from "@/storage/GpsDeviceStorage.js";
import GpsPositionStorage from "@/storage/GpsPositionStorage.js";
import AiPromptStorage from "@/storage/AiPromptStorage.js";

const store = createStore({
  modules: {
    auth,
    categorys,
    companys,
    employees,
    features,
    inspections,
    makers,
    options,
    questions,
    NoteStorage,

    register,
    repairs,
    repairResults,
    results,
    roles,
    schedules,
    signatures,
    signIn,
    types,
    users,
    vehicles,
    profile,
    events,

    ResultStorage,
    AddressStorage,
    AnswerStorage,
    AssetStorage,
    CommentStorage,
    InvoiceStorage,
    InvoiceSettingsStorage,
    CardStorage,

    AppStatsStorage,

    TimesheetEntryStorage,
    TimesheetStorage,

    CheckInStorage,
    GpsDeviceStorage,
    GpsPositionStorage,
    AiPromptStorage,
    EmployeePreferencesStorage,
    EmployeeRecordStorage,

    HomeState,
    TimesheetsState,
    InvoicesModel,
    InvoiceItemsStorage,
    PaymentStorage,

    CheckListStorage,
    ChecklistResultStorage,
    CheckListItemStorage,
    CheckListItemOptionStorage,
    ChecklistItemResultStorage,

    ImageStorage,
    EquipmentStorage,
    ReportStorage,
    LabelStorage,

    CompanyListViewStorage,
    EmployeeListViewStorage,
    InspectionListViewStorage,
    ReportListViewStorage,
    EquipmentListViewStorage,
    VehicleListViewStorage,
    ChecklistListVIewStorage,
    TimesheetListViewStorage,
    BillingListViewStorage,
    ComplianceListViewStorage,
    ScheduleListViewStorage,
    CardListViewStorage,

    RegistrationStorage,
    CredentialsStorage,
  },
  state: {},
  mutations: {},
  actions: {},
  getters: {}
});

loadFonts();

const app = createApp(App);

app.config.performance = true;
app.config.globalProperties.$uuid = uuidv4;

const pinia = createPinia();
app.use(pinia);

const head = createHead();
app.use(head);

app.use(VueCookies);
app.use(vuetify);
app.use(store);
app.use(VueNativeSock, process.env.VUE_APP_RC_API, {
  store: store,
  format: 'json',
  connectManually: true,
});



app.use(router);

app.mount('#app');